// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"flags_wrapper__VIakM"};